<template>
  <section v-show="active" class="app-modal__section">
    <header class="app-modal__section-head">
      <h4>{{ text.title }}</h4>
      <p>{{ text.subtitle }}</p>
    </header>

    <div class="app-modal__grid two-columns">
      <div class="app-modal-field full-width">
        <span>{{ text.tags }}</span>
        <multiselect
          v-model="form.tags"
          :options="options.tags"
          track-by="value"
          label="label"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :show-labels="false"
          :searchable="true"
          :allow-empty="true"
          class="app-modal-select expense-tags-select"
          :placeholder="text.placeholders.tags"
        >
          <template #noResult><span>{{ commonText.noOption }}</span></template>
          <template #noOptions><span>{{ commonText.noOption }}</span></template>
        </multiselect>
      </div>

      <div class="app-modal-field full-width">
        <span>{{ text.area }}</span>
        <multiselect
          v-model="form.area"
          :options="options.areas"
          track-by="value"
          label="label"
          :show-labels="false"
          :searchable="true"
          :allow-empty="true"
          :max-height="240"
          class="app-modal-select expense-area-select"
          :placeholder="text.placeholders.area"
        >
          <template #noResult><span>{{ commonText.noOption }}</span></template>
          <template #noOptions><span>{{ commonText.noOption }}</span></template>
        </multiselect>
      </div>

      <label class="app-modal-field full-width">
        <span>{{ text.comments }}</span>
        <textarea
          v-model.trim="form.comments"
          class="form-control app-modal-field__textarea"
          rows="4"
          :placeholder="text.placeholders.comments"
        ></textarea>
      </label>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ExpenseFeeModalSectionDetails',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    entityLabel: {
      type: String,
      default: 'gasto',
    },
    text: {
      type: Object,
      required: true,
    },
    commonText: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.expense-tags-select :deep(.multiselect__tags),
.expense-tags-select :deep(.multiselect-tags) {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  column-gap: 6px;
  row-gap: 6px;
  min-height: 36px !important;
  height: auto !important;
  padding: 10px 36px 10px 8px !important;
  overflow: hidden;
}

.expense-tags-select :deep(.multiselect__tags-wrap) {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  column-gap: 6px;
  row-gap: 6px;
  width: 100%;
  margin: 0;
  overflow: hidden;
}

.expense-tags-select :deep(.multiselect__tag),
.expense-tags-select :deep(.multiselect-tag) {
  background: #e9eff8;
  color: #334155;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  line-height: 1;
  min-height: 26px;
  padding: 0 24px 0 10px;
  margin: 0;
}

.expense-tags-select :deep(.multiselect__tag-icon:after),
.expense-tags-select :deep(.multiselect-tag-remove) {
  color: #64748b;
  line-height: 1;
  margin: 0;
}

.expense-area-select :deep(.multiselect__content-wrapper) {
  max-height: 240px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}
</style>
